export const TITLE = "Check Ava's proven success";
